module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dcvAH"))).then(() => parcelRequire('d0iPb'));